// Function to initialize mobile footer accordion
function initMobileFooterAccordion() {
  // Only run on mobile
  if (window.innerWidth <= 1024) {
    const footerSections = document.querySelectorAll('.footer-main .links-footer, .footer-main .social-media-footer');
    
    footerSections.forEach(function(section) {
      const header = section.querySelector('.footer-header');
      
      if (header && !header.hasAttribute('data-accordion-initialized')) {
        // Mark as initialized to prevent duplicate listeners
        header.setAttribute('data-accordion-initialized', 'true');
        
        header.addEventListener('click', function() {
          section.classList.toggle('active');
        });
      }
    });
  } else {
    // Desktop view - remove active classes and reset
    const footerSections = document.querySelectorAll('.footer-main .links-footer, .footer-main .social-media-footer');
    footerSections.forEach(function(section) {
      section.classList.remove('active');
      const header = section.querySelector('.footer-header');
      if (header) {
        header.removeAttribute('data-accordion-initialized');
      }
    });
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  initMobileFooterAccordion();
});

// Re-initialize on window resize with debounce
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    initMobileFooterAccordion();
  }, 250); // Wait 250ms after resize stops
});

// Mutation observer to watch for DOM changes (useful for AJAX-loaded content)
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      initMobileFooterAccordion();
    }
  });
});

// Start observing the document body for changes
if (document.body) {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Hide local pickup for non-BOPIS
document.addEventListener("DOMContentLoaded", function () {
    const hideUnavailablePickup = () => {
        // Select all elements with the class `store-availability-information`
        const availabilityElements = document.querySelectorAll("div.store-availability-information");

        availabilityElements.forEach(availability => {
            // Find the title element
            const titleElement = availability.querySelector("p.store-availability-information__title");

            // Check if the title contains "Pickup currently unavailable"
            if (titleElement && titleElement.textContent.trim().includes("Pickup currently unavailable")) {
                // Hide the entire parent container or the specific wrapper
                availability.style.display = "none"; // Alternatively, target a child element if needed
            }
        });
    };

    // Run the function initially to hide elements already in the DOM
    hideUnavailablePickup();

    // Set up MutationObserver to monitor dynamic changes
    const observer = new MutationObserver(() => {
        hideUnavailablePickup(); // Re-run the function on DOM changes
    });

    // Observe changes to the body or a narrower container
    observer.observe(document.body, {
        childList: true,  // Watch for added/removed child nodes
        subtree: true,    // Include changes in the entire subtree
    });
});